export const logout = () => {
	sessionStorage.setItem('token', '');
	sessionStorage.setItem('phone', '');
	sessionStorage.removeItem('forcedAuthSuccess');
	sessionStorage.removeItem('isExistsEmail');
	sessionStorage.removeItem('isExistsPhone');
	sessionStorage.removeItem('isExistsAnketa');
	window.location.reload()
}